var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 pt-2" },
    [
      _vm.offer.backLinkDTO
        ? _c("ob1-liens", {
            staticClass: "mb-1",
            attrs: {
              href: "#",
              text: _vm.offer.backLinkDTO.label,
              "is-back": true,
              "with-arrow": true,
            },
            on: {
              "ob1-liens-click": function ($event) {
                return _vm.handleBackLink($event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h1", { staticClass: "mb-0" }, [
        _vm._v("\n        " + _vm._s(_vm.offer.name) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.offer.hasBlockedVersion
          ? _c("div", { staticClass: "col-12 mt-1" }, [
              _c(
                "p",
                {
                  staticClass: "lead mb-0",
                  attrs: { "data-writefontsize": "" },
                },
                [_c("strong", [_vm._v(_vm._s(_vm.blockedOrNotLabel))])]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-12 col-md-3 order-md-2" }, [
          _vm.offer.discountBanner
            ? _c("strong", { staticClass: "ob1-tag ob1-tag-primary" }, [
                _vm._v(" " + _vm._s(_vm.offer.discountBanner)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.offer.prixDTO
            ? _c(
                "div",
                { staticClass: "mb-1" },
                [
                  _c("offer-price", {
                    attrs: {
                      price: _vm.offer.prixDTO.price,
                      "initial-price": _vm.offer.prixDTO.initialPrice,
                      "is-mini": false,
                      "show-by-month": true,
                      "show-promo-duration":
                        _vm.offer.prixDTO.showPromoDuration,
                      "show-until-end-of-promo": false,
                      duration: _vm.offer.prixDTO.duration,
                      "price-details": _vm.offer.commitmentLabel,
                      "is-cents-format": false,
                      "show-heart": false,
                      "custom-promo-duration": "p-0",
                      "custom-price-details": "padding-custom",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.offer.promotionConditionsDTO.text
            ? _c(
                "div",
                [
                  _c(
                    "ob1-liens-haut-bas",
                    {
                      staticClass: "mb-1",
                      attrs: {
                        "button-id": "promo-link",
                        "collapsed-block-id": "promo-conditions",
                        "button-label": _vm.offer.promotionConditionsDTO.title,
                        "is-mini": false,
                      },
                    },
                    [
                      _c("p", {
                        staticClass: "mb-0",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.offer.promotionConditionsDTO.text
                          ),
                        },
                      }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.offer.openMessage
            ? _c(
                "div",
                { staticClass: "mb-3" },
                [
                  _c("ob1-separateur", { attrs: { color: "gray3" } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex align-items-center py-1" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-grow-1" }, [
                      _c("strong", [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.offer.openMessage),
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("ob1-separateur", { attrs: { color: "gray3" } }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-md-5 pb-1 order-md-3",
            attrs: { id: "choose-links" },
          },
          [
            _c(
              "div",
              { staticClass: "d-flex flex-column" },
              [
                _vm.offer.addOfferDto
                  ? [
                      _c("p", { staticClass: "fw-bold mb-0" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.newClientLabel) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "visually-hidden" }, [
                        _vm._v(_vm._s(_vm.offerNameAccessibility)),
                      ]),
                      _vm._v(" "),
                      _vm.offer.addOfferDto.link
                        ? _c("ob1-boutons", {
                            staticClass: "mb-2",
                            attrs: {
                              "is-button": false,
                              label: _vm.offer.addOfferDto.label,
                              "is-primary": true,
                              "data-oevent-category": "fiche_forfait",
                              "data-oevent-action": _vm.offer.addOfferDto.label,
                              "data-oevent-label": "vers_tunnel",
                              href: _vm.offer.addOfferDto.link,
                            },
                          })
                        : _vm.offer.addOfferDto.popinWithDeviceDto
                        ? _c("offer-cta-with-device-popin", {
                            staticClass: "mb-2",
                            attrs: {
                              "is-primary": true,
                              label: _vm.offer.addOfferDto.label,
                              "offer-name": _vm.offer.name,
                              "popin-id": "addOfferWithDevicePopIn",
                              "popin-ctas-dto":
                                _vm.offer.addOfferDto.popinWithDeviceDto,
                              "tracking-category": "fiche_forfait",
                              "tracking-label": "vers_popin",
                            },
                          })
                        : _c("offer-cta-with-delivery-popin", {
                            staticClass: "mb-2",
                            attrs: {
                              "is-primary": true,
                              label: _vm.offer.addOfferDto.label,
                              "popin-id": "addOfferAllDisponibilitiesPopIn",
                              "popin-ctas-dto":
                                _vm.offer.addOfferDto.popinDeliveryDto,
                              "advantage-messages": _vm.advantageMessages,
                              "advantage-values": _vm.offer.advantageValues,
                              "is-online-recovery-available":
                                _vm.isOnlineRecoveryAvailable,
                              "offer-name": _vm.offer.name,
                              "tracking-category": "fiche_forfait",
                              "tracking-label": "vers_popin",
                            },
                          }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.offer.addOfferWithAuthenticationDto
                  ? [
                      _vm.offer.addOfferDto != null
                        ? _c("p", { staticClass: "fw-bold mb-0" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.alreadyClientLabel) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "visually-hidden" }, [
                        _vm._v(_vm._s(_vm.offerNameAccessibility)),
                      ]),
                      _vm._v(" "),
                      _vm.offer.addOfferWithAuthenticationDto.link
                        ? _c("ob1-boutons", {
                            staticClass: "mb-2",
                            attrs: {
                              "is-button": false,
                              label:
                                _vm.offer.addOfferWithAuthenticationDto.label,
                              "is-primary": _vm.offer.addOfferDto == null,
                              "is-secondary": _vm.offer.addOfferDto != null,
                              "data-oevent-category": "fiche_forfait",
                              "data-oevent-action":
                                _vm.offer.addOfferWithAuthenticationDto.label,
                              "data-oevent-label": "vers_tunnel",
                              href: _vm.offer.addOfferWithAuthenticationDto
                                .link,
                            },
                          })
                        : _vm.offer.addOfferWithAuthenticationDto
                            .popinWithDeviceDto
                        ? _c("offer-cta-with-device-popin", {
                            staticClass: "mb-2",
                            attrs: {
                              "is-primary": _vm.offer.addOfferDto == null,
                              label:
                                _vm.offer.addOfferWithAuthenticationDto.label,
                              "offer-name": _vm.offer.name,
                              "popin-id":
                                "addOfferWithAuthenticationAndDevicePopIn",
                              "popin-ctas-dto":
                                _vm.offer.addOfferWithAuthenticationDto
                                  .popinWithDeviceDto,
                              "tracking-category": "fiche_forfait",
                              "tracking-label": "vers_popin",
                            },
                          })
                        : _c("offer-cta-with-delivery-popin", {
                            staticClass: "mb-2",
                            attrs: {
                              "is-primary": _vm.offer.addOfferDto == null,
                              label:
                                _vm.offer.addOfferWithAuthenticationDto.label,
                              "popin-id":
                                "addOfferWithAuthenticationAllDisponibilitiesPopIn",
                              "popin-ctas-dto":
                                _vm.offer.addOfferWithAuthenticationDto
                                  .popinDeliveryDto,
                              "advantage-messages": _vm.advantageMessages,
                              "advantage-values": _vm.offer.advantageValues,
                              "is-online-recovery-available":
                                _vm.isOnlineRecoveryAvailable,
                              "offer-name": _vm.offer.name,
                              "tracking-category": "fiche_forfait",
                              "tracking-label": "vers_popin",
                            },
                          }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.offer.changeOfferDto
                  ? _c("ob1-boutons", {
                      attrs: {
                        "is-button": false,
                        label: _vm.offer.changeOfferDto.label,
                        "is-secondary": true,
                        "data-oevent-category": "fiche_forfait",
                        "data-oevent-action": _vm.offer.changeOfferDto.label,
                        "data-oevent-label": "validation offre",
                        href: _vm.offer.changeOfferDto.link,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.offer.selectedOfferButtonDTO
                  ? _c("ob1-boutons", {
                      attrs: {
                        "is-button": false,
                        label: _vm.offer.selectedOfferButtonDTO.label,
                        "is-primary": true,
                        "data-oevent-category": "fiche_forfait_iplusm",
                        "data-oevent-action": "retour_aux_offres",
                        "data-oevent-label": "vers_retour_aux_offres",
                        href: _vm.getSelectedOfferUrl,
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-md-4 order-md-1 mt-2 mt-md-0",
            attrs: { id: "offer-details-attributes" },
          },
          [
            _vm.offer.shortDescription
              ? _c("h4", {
                  staticClass: "mb-1",
                  domProps: { innerHTML: _vm._s(_vm.offer.shortDescription) },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("ob1-item-list", {
              attrs: { "item-list-d-t-o": _vm.offer.attributes },
            }),
            _vm._v(" "),
            _vm.infoOptions
              ? _c("ob1-message-alerte", {
                  staticClass: "row",
                  attrs: {
                    "is-simple-alerte": false,
                    type: "info",
                    title: _vm.infoOptions.title,
                    "liste-a-puces-dto": _vm.infoOptions.textsWithBulleted,
                    texts: _vm.infoOptions.texts,
                    "with-arrow-link": false,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-shrink-0" }, [
      _c("span", {
        staticClass: "icon icon-phone-fund-euro font-size-24 me-1 text-dark",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }